// Données des départements et communes DROM
// Sources: INSEE - Code officiel géographique

export const DROM_DEPARTMENTS = [
  { value: '971', label: 'Guadeloupe (971)' },
  { value: '972', label: 'Martinique (972)' },
  { value: '973', label: 'Guyane (973)' },
  { value: '974', label: 'La Reunion (974)' },
  { value: '976', label: 'Mayotte (976)' },
];

export const DROM_COMMUNES = {
  '971': [
    { value: 'anse_bertrand', label: 'Anse-Bertrand' },
    { value: 'baie_mahault', label: 'Baie-Mahault' },
    { value: 'baillif', label: 'Baillif' },
    { value: 'basse_terre', label: 'Basse-Terre' },
    { value: 'bouillante', label: 'Bouillante' },
    { value: 'capesterre_belle_eau', label: 'Capesterre-Belle-Eau' },
    { value: 'capesterre_marie_galante', label: 'Capesterre-de-Marie-Galante' },
    { value: 'deshaies', label: 'Deshaies' },
    { value: 'gourbeyre', label: 'Gourbeyre' },
    { value: 'goyave', label: 'Goyave' },
    { value: 'grand_bourg', label: 'Grand-Bourg' },
    { value: 'la_desirade', label: 'La Desirade' },
    { value: 'lamentin_971', label: 'Lamentin' },
    { value: 'le_gosier', label: 'Le Gosier' },
    { value: 'le_moule', label: 'Le Moule' },
    { value: 'les_abymes', label: 'Les Abymes' },
    { value: 'morne_a_leau', label: "Morne-a-l'Eau" },
    { value: 'petit_bourg', label: 'Petit-Bourg' },
    { value: 'petit_canal', label: 'Petit-Canal' },
    { value: 'pointe_a_pitre', label: 'Pointe-a-Pitre' },
    { value: 'pointe_noire', label: 'Pointe-Noire' },
    { value: 'port_louis', label: 'Port-Louis' },
    { value: 'saint_barthelemy', label: 'Saint-Barthelemy' },
    { value: 'st_barth_gustavia', label: 'Saint-Barthelemy - Gustavia' },
    { value: 'st_barth_saint_jean', label: 'Saint-Barthelemy - Saint-Jean' },
    { value: 'st_barth_lorient', label: 'Saint-Barthelemy - Lorient' },
    { value: 'st_barth_corossol', label: 'Saint-Barthelemy - Corossol' },
    { value: 'st_barth_flamands', label: 'Saint-Barthelemy - Flamands' },
    { value: 'st_barth_colombier', label: 'Saint-Barthelemy - Colombier' },
    { value: 'st_barth_grand_cul_de_sac', label: 'Saint-Barthelemy - Grand Cul-de-Sac' },
    { value: 'st_barth_saline', label: 'Saint-Barthelemy - Saline' },
    { value: 'st_barth_lurin', label: 'Saint-Barthelemy - Lurin' },
    { value: 'st_barth_toiny', label: 'Saint-Barthelemy - Toiny' },
    { value: 'saint_claude', label: 'Saint-Claude' },
    { value: 'saint_francois', label: 'Saint-Francois' },
    { value: 'saint_louis_971', label: 'Saint-Louis' },
    { value: 'saint_martin', label: 'Saint-Martin' },
    { value: 'st_martin_marigot', label: 'Saint-Martin - Marigot' },
    { value: 'st_martin_grand_case', label: 'Saint-Martin - Grand-Case' },
    { value: 'st_martin_quartier_orleans', label: "Saint-Martin - Quartier d'Orleans" },
    { value: 'st_martin_sandy_ground', label: 'Saint-Martin - Sandy Ground' },
    { value: 'st_martin_colombier', label: 'Saint-Martin - Colombier' },
    { value: 'st_martin_cul_de_sac', label: 'Saint-Martin - Cul-de-Sac' },
    { value: 'st_martin_oyster_pond', label: 'Saint-Martin - Oyster Pond' },
    { value: 'st_martin_terres_basses', label: 'Saint-Martin - Terres Basses' },
    { value: 'st_martin_baie_nettle', label: 'Saint-Martin - Baie Nettle' },
    { value: 'st_martin_anse_marcel', label: 'Saint-Martin - Anse Marcel' },
    { value: 'sainte_anne_971', label: 'Sainte-Anne' },
    { value: 'sainte_rose_971', label: 'Sainte-Rose' },
    { value: 'terre_de_bas', label: 'Terre-de-Bas' },
    { value: 'terre_de_haut', label: 'Terre-de-Haut' },
    { value: 'trois_rivieres', label: 'Trois-Rivieres' },
    { value: 'vieux_fort', label: 'Vieux-Fort' },
    { value: 'vieux_habitants', label: 'Vieux-Habitants' },
  ],
  '972': [
    { value: 'ajoupa_bouillon', label: 'Ajoupa-Bouillon' },
    { value: 'anses_darlet', label: "Anses-d'Arlet" },
    { value: 'basse_pointe', label: 'Basse-Pointe' },
    { value: 'bellefontaine', label: 'Bellefontaine' },
    { value: 'le_carbet', label: 'Le Carbet' },
    { value: 'case_pilote', label: 'Case-Pilote' },
    { value: 'le_diamant', label: 'Le Diamant' },
    { value: 'ducos', label: 'Ducos' },
    { value: 'fonds_saint_denis', label: 'Fonds-Saint-Denis' },
    { value: 'fort_de_france', label: 'Fort-de-France' },
    { value: 'le_francois', label: 'Le Francois' },
    { value: 'grand_riviere', label: "Grand'Riviere" },
    { value: 'gros_morne', label: 'Gros-Morne' },
    { value: 'lamentin_972', label: 'Le Lamentin' },
    { value: 'le_lorrain', label: 'Le Lorrain' },
    { value: 'macouba', label: 'Macouba' },
    { value: 'le_marigot', label: 'Le Marigot' },
    { value: 'le_marin', label: 'Le Marin' },
    { value: 'le_morne_rouge', label: 'Le Morne-Rouge' },
    { value: 'le_morne_vert', label: 'Le Morne-Vert' },
    { value: 'le_precheur', label: 'Le Precheur' },
    { value: 'riviere_pilote', label: 'Riviere-Pilote' },
    { value: 'riviere_salee', label: 'Riviere-Salee' },
    { value: 'le_robert', label: 'Le Robert' },
    { value: 'saint_esprit', label: 'Saint-Esprit' },
    { value: 'saint_joseph_972', label: 'Saint-Joseph' },
    { value: 'saint_pierre_972', label: 'Saint-Pierre' },
    { value: 'sainte_anne_972', label: 'Sainte-Anne' },
    { value: 'sainte_luce', label: 'Sainte-Luce' },
    { value: 'sainte_marie_972', label: 'Sainte-Marie' },
    { value: 'schoelcher', label: 'Schoelcher' },
    { value: 'la_trinite', label: 'La Trinite' },
    { value: 'les_trois_ilets', label: 'Les Trois-Ilets' },
    { value: 'le_vauclin', label: 'Le Vauclin' },
  ],
  '973': [
    { value: 'apatou', label: 'Apatou' },
    { value: 'awala_yalimapo', label: 'Awala-Yalimapo' },
    { value: 'camopi', label: 'Camopi' },
    { value: 'cayenne', label: 'Cayenne' },
    { value: 'grand_santi', label: 'Grand-Santi' },
    { value: 'iracoubo', label: 'Iracoubo' },
    { value: 'kourou', label: 'Kourou' },
    { value: 'macouria', label: 'Macouria' },
    { value: 'mana', label: 'Mana' },
    { value: 'maripasoula', label: 'Maripasoula' },
    { value: 'matoury', label: 'Matoury' },
    { value: 'montsinery_tonnegrande', label: 'Montsinery-Tonnegrande' },
    { value: 'ouanary', label: 'Ouanary' },
    { value: 'papaichton', label: 'Papaichton' },
    { value: 'regina', label: 'Regina' },
    { value: 'remire_montjoly', label: 'Remire-Montjoly' },
    { value: 'roura', label: 'Roura' },
    { value: 'saint_elie', label: 'Saint-Elie' },
    { value: 'saint_georges', label: 'Saint-Georges' },
    { value: 'saint_laurent_du_maroni', label: 'Saint-Laurent-du-Maroni' },
    { value: 'saul', label: 'Saul' },
    { value: 'sinnamary', label: 'Sinnamary' },
  ],
  '974': [
    { value: 'bras_panon', label: 'Bras-Panon' },
    { value: 'cilaos', label: 'Cilaos' },
    { value: 'entre_deux', label: 'Entre-Deux' },
    { value: 'letang_sale', label: "L'Etang-Sale" },
    { value: 'la_plaine_des_palmistes', label: 'La Plaine-des-Palmistes' },
    { value: 'la_possession', label: 'La Possession' },
    { value: 'le_port', label: 'Le Port' },
    { value: 'le_tampon', label: 'Le Tampon' },
    { value: 'les_avirons', label: 'Les Avirons' },
    { value: 'les_trois_bassins', label: 'Les Trois-Bassins' },
    { value: 'petite_ile', label: 'Petite-Ile' },
    { value: 'saint_andre', label: 'Saint-Andre' },
    { value: 'saint_benoit', label: 'Saint-Benoit' },
    { value: 'saint_denis', label: 'Saint-Denis' },
    { value: 'saint_joseph_974', label: 'Saint-Joseph' },
    { value: 'saint_leu', label: 'Saint-Leu' },
    { value: 'saint_louis_974', label: 'Saint-Louis' },
    { value: 'saint_paul', label: 'Saint-Paul' },
    { value: 'saint_philippe', label: 'Saint-Philippe' },
    { value: 'saint_pierre_974', label: 'Saint-Pierre' },
    { value: 'sainte_marie_974', label: 'Sainte-Marie' },
    { value: 'sainte_rose_974', label: 'Sainte-Rose' },
    { value: 'sainte_suzanne', label: 'Sainte-Suzanne' },
    { value: 'salazie', label: 'Salazie' },
  ],
  '976': [
    { value: 'acoua', label: 'Acoua' },
    { value: 'bandraboua', label: 'Bandraboua' },
    { value: 'bandrele', label: 'Bandrele' },
    { value: 'boueni', label: 'Boueni' },
    { value: 'chiconi', label: 'Chiconi' },
    { value: 'chirongui', label: 'Chirongui' },
    { value: 'dembeni', label: 'Dembeni' },
    { value: 'dzaoudzi', label: 'Dzaoudzi' },
    { value: 'kani_keli', label: 'Kani-Keli' },
    { value: 'koungou', label: 'Koungou' },
    { value: 'mamoudzou', label: 'Mamoudzou' },
    { value: 'mtsamboro', label: 'Mtsamboro' },
    { value: 'mtsangamouji', label: "M'Tsangamouji" },
    { value: 'ouangani', label: 'Ouangani' },
    { value: 'pamandzi', label: 'Pamandzi' },
    { value: 'sada', label: 'Sada' },
    { value: 'tsingoni', label: 'Tsingoni' },
  ],
};

// Labels de département pour l'affichage
export const DEPARTMENT_LABELS = {
  '971': 'Guadeloupe',
  '972': 'Martinique',
  '973': 'Guyane',
  '974': 'La Reunion',
  '976': 'Mayotte',
};

// Taux Pinel Outre-mer (identiques pour tous les DROM)
export const PINEL_OUTRE_MER_RATES = {
  6: { rate: 0.23, label: '6 ans (23%)' },
  9: { rate: 0.29, label: '9 ans (29%)' },
  12: { rate: 0.32, label: '12 ans (32%)' },
};
